import { render, staticRenderFns } from "./rental-space-img.vue?vue&type=template&id=3095c2d6&scoped=true"
import script from "./rental-space-img.vue?vue&type=script&lang=js"
export * from "./rental-space-img.vue?vue&type=script&lang=js"
import style0 from "./rental-space-img.vue?vue&type=style&index=0&id=3095c2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3095c2d6",
  null
  
)

export default component.exports